import React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import DownloadIcon from '@mui/icons-material/GetApp';
import "./UserInfoDialog.css"

export default class UserInfoDialog extends React.Component {

  state = {
    open: false,
    willSubscribe: true,
    emailAddress: "",
    postalCode: "",
    affiliation: "academic",
    requestedDownloadType: "csv"
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleSubmit = (event) => {
    let { target: form } = event;
    event.preventDefault();
    console.log(this.state);
    if (form.checkValidity()) {
      this.sendData()
    }
  }

  setDownloadType = (type) => {
    this.setState({ requestedDownloadType: type });
  }

  downloadAsset = (event) => {
    let { requestedDownloadType: downloadType } = this.state;
    let linkSelector = downloadType === "csv" ? "#downloadAsset" : "#downloadPDFAsset";
    let assetLink = document.querySelector(linkSelector);
    assetLink.click();
  }

  sendData = () => {
    let { emailAddress: userEmail, postalCode: userZipcode, willSubscribe: subscribe, affiliation } = this.state;
    window.dataLayer && window.dataLayer.push({ userEmail, userZipcode, subscribe, affiliation });
    this.downloadAsset();
    this.handleClose();
  }

  handleSubscribeChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  handleChange = event => {
    let { name, value } = event.target;
    this.setState({ [name]: value });
  };

  render() {
    return (
      <div>
        <Button variant="contained" color="primary" onClick={this.handleClickOpen}>Download Data</Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <form id="userInfoDialog" ref={ref => this.userInfoDialog = ref} action="" onSubmit={this.handleSubmit} method="post">
            <DialogTitle id="form-dialog-title">Download</DialogTitle>
            <DialogContent>
               <DialogContentText>
                {/* To download generated results, we ask that you provide some information to help us improve the SASSY Group Scoring tool. */}
                Use the links below to download your dataset or to save a copy of your report.
              </DialogContentText>
              {/* <div>
                <FormGroup className="contact-fields">
                  <TextField
                    className="contact-field"
                    autoFocus
                    margin="normal"
                    id="emailAddress"
                    name="emailAddress"
                    label="Email Address"
                    type="email"
                    autoComplete="email"
                    onChange={this.handleChange}
                    required
                  />
                  <TextField
                    className="contact-field"
                    margin="normal"
                    id="postalCode"
                    name="postalCode"
                    label="Zip Code"
                    type="text"
                    autoComplete="postal-code"
                    minLength="5"
                    maxLength="5"
                    helperText="Five-digit zip code, e.g. 06511."
                    onChange={this.handleChange}
                    inputProps={{ 'pattern': '\\d{5}' }}
                    required
                  />
                </FormGroup>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Affiliation</FormLabel>
                  <RadioGroup
                    aria-label="Affiliation"
                    name="affiliation"
                    className="user-affiliation"
                    value={this.state.affiliation}
                    onChange={this.handleChange}>
                    <FormControlLabel value="academic" control={<Radio />} label="Academic/Educator" />
                    <FormControlLabel value="business" control={<Radio />} label="Business" />
                    <FormControlLabel value="government" control={<Radio />} label="Government" />
                    <FormControlLabel value="other" control={<Radio />} label="Other" />
                  </RadioGroup>
                </FormControl>
                <FormGroup>
                  <FormControlLabel control={<Checkbox onChange={this.handleSubscribeChange('willSubscribe')} checked={this.state.willSubscribe} value="Subscribe" />} label={<p>Subscribe to the <b>Yale Program for Climate Change Communication</b> mailing list.</p>} />
                </FormGroup>
              </div> */}
            </DialogContent>
            <DialogActions>
              {/* <Button onClick={this.handleClose}>
                Cancel
              </Button> */}
              <Button id="downloadAsset" href={this.props.assetUrl} target="_blank" aria-label="Download Asset" rel="noopener noreferrer" download={this.props.filename + " Segmentation.csv"} type="text/csv">Download CSV</Button>
              <Button id="downloadPDFAsset" href={this.props.pdfLink} target="_blank" aria-label="Download PDF Asset" rel="noopener noreferrer" download={this.props.filename + " Segmentation.pdf"} type="application/pdf">Download PDF</Button>


              <Button color="primary" onClick={() => this.setDownloadType("csv")} name="SASSY Data" aria-label="Download Results" rel="noopener noreferrer" type="submit">Export Data (CSV)<DownloadIcon /></Button>
              <Button color="primary" onClick={() => this.setDownloadType("pdf")} name="SASSY Data PDF" aria-label="Download PDF" rel="noopener noreferrer" type="submit">Download PDF<DownloadIcon /></Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    );
  }
}
